<template>
  <div class="indexPage">
    <div class="headerShow">
      <common-header :menu-list="menuList" :menuActive="menuActive"
                     @logoClick="logoClick"
                     @menuClick="menuClick"></common-header>
    </div>
    <div class="pageMain">

      <div class="swiper-container pageSwiper" ref="pageChangeSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide mySlide">
            <div class="iconAndChannel">
              <div class="leftIcon">
                <img :src="imagePathIcon" alt="">
              </div>
              <div class="rightInfo">
                <div class="textShowIcon">
                  <img :src="!isTimedShow?imgIconTextReserve:imgIconText" alt="">
                </div>
                <div class="appleAndGoogle">
                  <div class="apple" @click="appleOrGoogle('apple')">
                    <img :src="!isTimedShow?appleImgReservePath:appleImgDownPath" alt="">
                  </div>
                  <div class="google" @click="appleOrGoogle('google')">
                    <img :src="!isTimedShow?googleImgReservePath:googleImgDownPath" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-container swiper-container-page1" ref="pageOneBanner">
              <!-- Swiper 包装器 -->
              <div class="swiper-wrapper">
                <!-- Swiper 项 -->
                <div v-for="item in bannerListShow" :key="item.id + 'banner'" class="swiper-slide">
                  <div class="bannerShow">
                    <img :src="item.bannerUrl" alt="">
                  </div>
                </div>
                <!-- ... -->
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
          <div v-if="$i18n.locale === 'tw'" class="swiper-slide page2Slide">
            <div class="page2Main">
              <div class="page2Title">
                {{ page2Title }}
              </div>
              <div class="page2Content">
                <div class="leftList" ref="page2Left">
                  <div class="tabList" ref="leftTab">
                    <div v-for="item in page2Tabs" :key="item.id + 'tags'" class="tabListShow"
                         :class="{'tabListActive':item.id === page2TagActive}" @click="tabChange(item)">
                      {{ item.label }}
                    </div>
                  </div>
                  <div class="tabInfosShow" ref="leftTabInfo">
                    <div v-for="item in tabInfosList" :key="item.id" class="tabInfosList">
                      <div class="infoListHeader">
                        <div class="tagAndTime">
                          <div class="tagShow" :style="{'background-color':tabTagColor[item.parentId]}">
                            {{ page2TabTagLib[item.parentId] }}
                          </div>
                          <div class="timeShow">
                            {{ formatDate(item.pubTime) }}
                          </div>
                        </div>
                      </div>
                      <div class="infoListContent"
                           :class="{'infoListNewContent':checkShowNew(item)}"
                           @click="toDetail(item)">
                        {{ item.title }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rightTwitter" ref="page2Right">
                  <div v-if="pageLanguage === 'japan'" class="twitterShow">
                    <!--嵌入推特内容-->
                    <a class="twitter-timeline" data-width="540"
                       href="https://twitter.com/clutch_hit_JP">Tweets by
                      clutch_hit</a>
                  </div>
                  <div v-if="pageLanguage === 'tc'" class="faceBookShow">
                    <div id="fb-root">
                      <div class="fb-page" data-href="https://www.facebook.com/MLBClutchHitBaseballTaiwan"
                           data-tabs="timeline" data-width="540" data-height="" data-small-header="false"
                           data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
                        <blockquote cite="https://www.facebook.com/MLBClutchHitBaseballTaiwan"
                                    class="fb-xfbml-parse-ignore"><a
                            href="https://www.facebook.com/MLBClutchHitBaseballTaiwan">MLB制勝時刻Taiwan</a>
                        </blockquote>
                      </div>
                    </div>
                  </div>
                  <div v-if="pageLanguage === 'korean'" class="faceBookShow">
                    <div id="fb-root">
                      <div class="fb-page" data-href="https://www.facebook.com/profile.php?id=61555540829232"
                           data-tabs="timeline" data-width="540" data-height="" data-small-header="false"
                           data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
                        <blockquote cite="https://www.facebook.com/profile.php?id=61555540829232"
                                    class="fb-xfbml-parse-ignore"><a
                            href="https://www.facebook.com/profile.php?id=61555540829232">MLB 클러치 히트 베이스볼</a>
                        </blockquote>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide page3Slide">
            <div class="page3Main">
              <div class="swiperPage3Main">
                <div class="leftContent">
                  <div class="leftTitleShow">
                    {{ page3Title }}
                  </div>
                  <div class="leftDetail">
                    {{ page3Content }}
                  </div>
                  <div class="page3Swiper-pagination"></div>
                </div>
                <div class="swiper-container swiper-container-page3" ref="pageThreeBanner">
                  <div class="swiper-wrapper">
                    <div v-for="item in page3Swiper" :key="item.id + 'page3'" class="swiper-slide">
                      <div class="rightImg">
                        <img :src="page3SwiperImgLib[item.id]" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide page4Slide">
            <div class="page4Main">
              <div class="titleShow">
                {{ page4Title }}
              </div>
              <div class="cardList">
                <div v-for="item in cardListImgs" :key="item.id + 'card'" class="cardListShow" @click="toUrl(item)">
                  <img :src="item.bannerUrl" alt="">
                </div>
              </div>
            </div>
            <div class="page4Bottom">
              <page-bottom-taiwan v-if="$i18n.locale === 'tw'"></page-bottom-taiwan>
              <page-bottom v-else :rules="bottomRules" :icon-link="bottomIconLink"
              :language="pageLanguage"></page-bottom>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from "@/components/CommonHeader/index.vue";
import pageBottom from "@/components/PageBottom/index.vue";
import PageBottomTaiwan from "@/components/PageBottomTaiwan/index.vue";
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入

import {mapMutations} from 'vuex'
import Cookies from 'js-cookie'

import {getNewsList, getNewsListByTab, getCardList, getBannerById} from '@/api/index'
const iconMap = {
  tw: 'tc',
  kr: 'korean',
  jp: 'japan'
}
export default {
  name: 'indexPage',
  components: {commonHeader, pageBottom, PageBottomTaiwan},
  data() {
    return {
      pageLanguage: '',
      menuList: [],
      menuActive: 'home',
      mySwiper: '',
      page2Title: '',
      page1Banner: '',
      page3Banner: '',
      page2Tabs: [],
      page2TabsLib: {},
      page2TabTagLib: {},
      page2TagActive: 'all',
      tabInfosList: [], // tab内容展示
      page3Swiper: [],
      page3SwiperImgLib: {
        1: require('@/assets/imgs/commonImg/page3Img1.png'),
        2: require('@/assets/imgs/commonImg/page3Img2.png'),
        3: require('@/assets/imgs/commonImg/page3Img3.png'),
      },
      page4Title: '',
      bottomRules: [],
      pageMainId: '',
      iconTextShow: '',
      bannerId: '', // 拉取banner
      cardParamId: '',
      cardListImgs: [],
      bannerListShow: [],
      tabTagColor: {},
      page3Title: '',
      page3Content: '',
      bottomIconLink: [],
      isTimedShow: false, // 定时展示
      downLink: {} // 点击图标下载
    }
  },
  computed: {
    imgIconTextReserve() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/iconTextReserve.png`);
    },
    imgIconText() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/iconText.png`);
    },
    imagePathIcon() {
      // return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/icon.png`);
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/iconNew.png`);
    },
    appleImgPath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/apple.png`);
    },
    appleImgReservePath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/appleReserve.png`);
    },
    appleImgDownPath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/appleDown.png`);
    },
    googleImgPath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/google.png`);
    },
    googleImgReservePath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/googleReserve.png`);
    },
    googleImgDownPath() {
      return require(`@/assets/imgs/${iconMap[this.$i18n.locale]}/googleDown.png`);
    },
    indexPage() {
      return this.$store.state.indexPage;
    },
    tabActive() {
      return this.$store.state.tabActive;
    },
    title() {
      return this.$t('title');
    }
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: '%s'
    }
  },
  created() {
    this.setI18nInfos()
  },
  mounted() {
    this.setupTimer();
    this.initializationSwiper()
    this.$nextTick(function () {
      this.addFacebookSDK();
    })
    this.bannerList()
    this.cardList()
    let row = {id: this.tabActive}
    this.tabChange(row)
  },
  methods: {
    ...mapMutations(['SET_LANGUAGE', 'SET_INDEX_PAGE', 'SET_TAB_ACTIVE']),
    // 初始化swiper和Banner
    initializationSwiper() {
      this.mySwiper = new Swiper(this.$refs.pageChangeSwiper, {
        // effect: "fade",
        direction: "vertical",
        speed: 500,
        mousewheel: true,
        fade: {
          crossFade: true,
        },
        on: {
          init: function () {
            // 在初始化时禁止第一页上拉
            this.allowTouchMove = false;
          },
          slideChange: () => {
            const currentLocale = this.$i18n.locale;
            let menuLib = {
              0: 'home',
              1: 'news',
              2: 'feature',
              3: 'activity'
            }
            if (currentLocale !== 'tw'){
              menuLib = {
                0: 'home',
                1: 'feature',
                2: 'activity'
              }
            }
            this.menuActive = menuLib[this.mySwiper.activeIndex];
            // this.mySwiper.allowTouchMove = !(this.mySwiper.activeIndex === 0 || this.mySwiper.activeIndex === this.mySwiper.slides.length - 1);
          },
        },
      })
      // this.page1Banner = new Swiper(this.$refs.pageOneBanner, {
      //   speed: 1000,
      //   // autoplay: {
      //   //   delay: 2000,
      //   // },
      //   // loop: true, // 设置为 true 来启用无限循环滚动
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true,
      //   },
      // });
      this.page3Banner = new Swiper(this.$refs.pageThreeBanner, {
        speed: 1000,
        autoplay: {
          delay: 2000,
        },
        loop: true, // 设置为 true 来启用无限循环滚动
        pagination: {
          el: '.page3Swiper-pagination',
          clickable: true,
        },
        on: {
          slideChange: () => {
            let index = this.page3Banner.realIndex
            if (index <= this.page3Swiper.length) {
              this.page3Title = this.page3Swiper[index].title
              this.page3Content = this.page3Swiper[index].content
            }
          },
        }
      });
      if (this.indexPage && this.indexPage !== '') {
        let lib = {
          home: 0,
          news: 1,
          feature: 2,
          activity: 3
        }
        this.mySwiper.slideTo(lib[this.indexPage])
        this.SET_INDEX_PAGE('')
      }
    },
    initializationPageSwiper() {
      if (this.page1Banner) {
        this.page1Banner.destroy();
      }
      this.$nextTick(() => {
        this.page1Banner = new Swiper(this.$refs.pageOneBanner, {
          speed: 1000,
          autoplay: {
            delay: 2000,
          },
          loop: false, // 设置为 true 来启用无限循环滚动
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
        if (this.bannerListShow.length > 1){
          this.page1Banner.loop = true
        }
      })
    },
    // 初始化faceBook
    addFacebookSDK() {
      let script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      if (this.pageLanguage === 'tc'){
        script.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v18.0';
        script.nonce = 'u9ChaOBc'
      }else if (this.pageLanguage === 'korean') {
        script.src = 'https://connect.facebook.net/ko_KR/sdk.js#xfbml=1&version=v18.0';
        script.nonce = '2QQccd0Y'
      }else {
        script.src = 'https://platform.twitter.com/widgets.js'
      }
      document.body.appendChild(script);
    },
    // 赋值i18n数据
    setI18nInfos() {
      const currentLocale = this.$i18n.locale; // 获取当前语言
      const messages = this.$i18n.getLocaleMessage(currentLocale); // 获取当前语言的所有消息
      this.downLink = messages.downLinkArea
      let localLib = {
        kr: 'korean',
        jp: 'japan',
        tw: 'tc'
      }
      this.pageLanguage = localLib[currentLocale]
      this.menuList = messages.menu
      this.page2Title = messages.page2.title
      this.page2Tabs = messages.page2.tabs
      this.page2TabsLib = messages.page2.tabLib
      this.page2TabTagLib = messages.page2.tabTagLib
      this.page3Swiper = messages.page3
      this.page4Title = messages.page4.title
      this.bottomRules = messages.pageBottom.ruleList
      this.pageMainId = messages.pageMainId
      this.iconTextShow = messages.iconTextShow
      this.cardParamId = messages.page4.getCardId
      this.bannerId = messages.bannerId
      this.tabTagColor = messages.page2.tabLibColor
      this.bottomIconLink = messages.pageBottom.iconAndLink

      this.page3Title = this.page3Swiper[0].title
      this.page3Content = this.page3Swiper[0].content

    },
    logoClick() {
      this.mySwiper.slideTo(0)
    },
    menuClick(row) {
      const currentLocale = this.$i18n.locale;
      let toLib = {
        home: 0,
        news: 1,
        feature: 2,
        activity: 3
      }
      if (currentLocale !== 'tw'){
        toLib = {
          home: 0,
          feature: 1,
          activity: 2
        }
      }
      this.mySwiper.slideTo(toLib[row.id]);
      this.menuActive = row.id
    },
    tabChange(row) {
      this.page2TagActive = row.id
      let param = {
        current: 1,
        gameType: 6,
        parentId: this.page2TabsLib[row.id] - 0,
        size: 6
      }
      if (row.id === 'all') {
        getNewsList(param).then(res => {
          if (res.data.code === 0) {
            this.tabInfosList = res.data.data
            this.setRightHeight()
          } else {
            console.log('error');
            console.log(res);
          }
        })
      } else {
        getNewsListByTab(param).then(res => {
          if (res.data.code === 0) {
            let data = res.data.data
            this.tabInfosList = data.records
            this.setRightHeight()
          } else {
            console.log('error');
            console.log(res);
          }
        })
      }
    },
    setRightHeight() {
      this.$nextTick(() => {
        // let leftHeight = this.$refs.page2Left.offsetHeight;
        let leftTabHeight = this.$refs.leftTab.offsetHeight;
        let leftTabInfoHeight = this.$refs.leftTabInfo.offsetHeight;
        let leftHeight = leftTabHeight + leftTabInfoHeight
        this.$refs.page2Right.style.height = `${leftHeight}px`;
      })
    },
    bannerList() {
      let param = {
        gameType: 6,
        parentId: this.bannerId,
        current: 1,
        size: 6,
        status: '0'
      }
      getBannerById(param).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          if (data.records.length > 0) {
            this.bannerListShow = data.records
            this.initializationPageSwiper()
          } else {
            alert('资源更新中');
          }
        } else {
          console.log('error');
          console.log(res);
        }
      })
    },
    cardList() {
      let param = {
        gameType: 6,
        parentId: this.cardParamId,
        current: 1,
        size: 10
      }
      getCardList(param).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          if (data.records.length > 0) {
            this.cardListImgs = data.records
          } else {
            alert('资源更新中');
          }
        } else {
          console.log('error');
          console.log(res);
        }
      })
    },
    toUrl(row) {
      window.open(row.linkUrl, '_blank');
    },
    pageLanguageShow(row) { // 选择页面语言
      if (row.id !== this.pageLanguage) {
        this.pageLanguage = row.id
        this.SET_LANGUAGE(this.pageLanguage)  // 更新 Vuex 中的语言
        Cookies.set('language', this.pageLanguage)  // 将语言保存到 cookies 中
        location.reload();
      }
    },
    checkShowNew(row) {
      if (row.pubTime) {
        let date = new Date(row.pubTime);
        let now = new Date();
        let sixDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
        return date >= sixDaysAgo;
      } else {
        return false
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero based
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    appleOrGoogle(flag) {
      window.open(this.downLink[flag], '_blank');
    },
    toDetail(row) {
      this.SET_TAB_ACTIVE(this.page2TagActive)
      const currentLang = this.$i18n.locale; // 获取当前语言
      this.$router.push({path: `/${currentLang}/detail`, query: {id: row.id}})
    },
    setupTimer() { // 定时展示部分内容
      const targetDate = new Date('2024-05-30T10:00:00');
      const now = new Date();
      const delay = targetDate - now;
      if (delay > 0) {
        setTimeout(() => {
          this.isTimedShow = true;
        }, delay);
      } else {
        // 如果当前时间已经超过目标时间，直接显示内容
        this.isTimedShow = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.indexPage {
  height: 100%;
  width: 100%;
  //padding-top: 60px;
  box-sizing: border-box;
  @media screen and (max-width: 1920px) {
    .headerShow {
      position: fixed;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 62px;
      background: #152c58;
    }
  }
  @media screen and (min-width: 1921px) and (max-width: 2560px) {
    .headerShow {
      position: fixed;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 82px;
      background: #152c58;
    }
  }
  @media screen and (min-width: 2561px) {
    .headerShow {
      position: fixed;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 102px;
      background: #152c58;
    }
  }

  .pageMain {
    width: 100%;
    height: 100%;
    position: relative;

    .iconAndChannel {
      position: absolute;
      bottom: 10px;
      left: 10px;
      display: flex;
      z-index: 2;
      padding: 5px;
      background: url("@/assets/imgs/iconBgShow.png") no-repeat bottom center;

      .leftIcon {
        height: 100px;
        width: 100px;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .rightInfo {
        margin-left: 10px;
        display: flex;
        flex-flow: column;
        justify-content: flex-end;

        .textShow {
          text-align: center;
          color: white;
        }

        .textShowIcon {
          height: 40px;
          text-align: left;
          img {
            height: 100%;
          }
        }

        @media screen and (max-width: 1920px) {
          .appleAndGoogle {
            margin-top: 10px;
            width: 240px;
            display: flex;

            .apple {
              cursor: pointer;
              height: 33px;

              img {
                height: 100%;
              }
            }

            .google {
              margin-left: 10px;
              cursor: pointer;
              height: 33px;

              img {
                height: 100%;
              }
            }
          }
        }
        @media screen and (min-width: 1921px) and (max-width: 2560px) {
          .appleAndGoogle {
            margin-top: 10px;
            width: 240px;
            display: flex;

            .apple {
              cursor: pointer;
              height: 53px;

              img {
                height: 100%;
              }
            }

            .google {
              margin-left: 10px;
              cursor: pointer;
              height: 53px;

              img {
                height: 100%;
              }
            }
          }
        }
        @media screen and (min-width: 2561px) {
          .appleAndGoogle {
            margin-top: 10px;
            display: flex;

            .apple {
              cursor: pointer;
              height: 80px;

              img {
                height: 100%;
              }
            }

            .google {
              margin-left: 10px;
              cursor: pointer;
              height: 80px;

              img {
                height: 100%;
              }
            }
          }
        }
      }
    }

    .lastPageIcon {
      bottom: 210px !important;
    }

    .pageSwiper {
      width: 100%;
      height: 100%;
    }

    .mySlide {
      position: relative;
      background: white;
    }

    @media screen and (max-width: 1920px) {
      .page2Slide {
        background: url("@/assets/imgs/page2Bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
      }
    }
    @media screen and (min-width: 1921px) {
      .page2Slide {
        background: url("@/assets/imgs/page2Bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
      }
    }

    .page3Slide {
      background-size: contain;
      background: url("@/assets/imgs/page3Bg.png") round;
      display: flex;
    }

    .page4Slide {
      background-size: contain;
      background: url("@/assets/imgs/page4Bg.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      display: flex;
      align-items: center;

      .page4Bottom {
        width: 100%;
        position: absolute;
        bottom: 0;
      }
    }

    .swiper-container-page1 {
      height: 100%;
      .bannerShow {
        height: 100%;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }

    @media screen and (max-width: 1920px) {
      .page2Main {
        //width: 870px;
        //margin: 5% auto auto;
        margin-top: 5%;
        .page2Title {
          color: white;
          text-align: center;
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 30px;
        }

        .page2Content {
          width: 70vw;
          height: auto;
          display: flex;
          justify-content: center;
          align-items: stretch;
          .leftList {
            flex: 5;
            //height: 65vh;
            background: #fffffff5;
            margin-right: 10px;
            .tabList {
              display: flex;
              background: white;

              .tabListShow {
                flex: 1;
                height: 45px;
                line-height: 45px;
                color: #808080;
                cursor: pointer;
              }

              .tabListActive {
                color: white !important;
                background: url("@/assets/imgs/tabBg.png");
                background-size: 100% 100%;
              }
            }

            .tabInfosShow {
              padding: 0 10px;
              overflow: auto;
              height: 450px;
              .tabInfosList {
                padding: 10px 0;
                border-bottom: 1px solid #D9D9D9;
                border-bottom-style: dashed;

                .infoListHeader {
                  display: flex;
                  justify-content: space-between;

                  .tagAndTime {
                    display: flex;
                    align-items: center;

                    .tagShow {
                      position: relative;
                      color: white;
                      height: 20px;
                      line-height: 20px;
                      padding: 0 15px 0 10px;
                    }

                    .tagShow::before {
                      content: "";
                      position: absolute;
                      bottom: 0;
                      right: 0;
                      width: 0;
                      height: 0;
                      border-left: 10px solid transparent;
                      border-bottom: 20px solid white;
                    }

                    .timeShow {
                      margin-left: 10px;
                      color: #404040;
                      font-size: 14px;
                    }
                  }
                }

                .infoListContent {
                  cursor: pointer;
                  margin-top: 5px;
                  font-size: 20px;
                  font-weight: 500;
                  color: #013c80;
                  text-align: left;
                }

                .infoListNewContent {
                  position: relative;
                  color: #CF0B1E !important;
                }

                .infoListNewContent::after {
                  content: "New";
                  color: #fff;
                  background: linear-gradient(0deg, #DD3037 0%, #B61D2C 100%);
                  border-radius: 5px 5px 5px 0;
                  padding: 2px;
                  margin-left: 5px;
                  font-size: 8px;
                  position: absolute;
                  bottom: 20px;
                }
              }
            }

            .tabInfosShow::-webkit-scrollbar {
              width: 5px;
              height: 100%;
            }

            // 滑块
            .tabInfosShow::-webkit-scrollbar-thumb {
              width: 5px;
              height: 60px;
              background-color: #ccc;
              border-radius: 3px;
            }
          }

          .rightTwitter {
            flex: 3;
            //height: 495px;
            background-color: white;
            overflow: auto;
          }

          .rightTwitter::-webkit-scrollbar {
            width: 5px;
            height: 100%;
          }

          // 滑块
          .rightTwitter::-webkit-scrollbar-thumb {
            width: 5px;
            height: 60px;
            background-color: #ccc;
            border-radius: 3px;
          }
        }
      }
    }
    @media screen and (min-width: 1921px) and (max-width: 2560px) {
      .page2Main {
        width: 60%;
        margin: auto;

        .page2Title {
          color: white;
          text-align: center;
          font-size: 50px;
          font-weight: bold;
          margin-bottom: 50px;
        }

        .page2Content {
          height: auto;
          display: flex;
          justify-content: center;
          align-items: stretch;
          .leftList {
            flex: 5;
            //height: 65vh;
            background: #fffffff5;
            margin-right: 20px;

            .tabList {
              display: flex;
              background: white;

              .tabListShow {
                flex: 1;
                height: 65px;
                line-height: 65px;
                font-size: 20px;
                color: #808080;
                cursor: pointer;
              }

              .tabListActive {
                color: white !important;
                background: url("@/assets/imgs/tabBg.png");
                background-size: 100% 100%;
              }
            }

            .tabInfosShow {
              padding: 0 10px;
              //height: calc(100% - 70px);
              height: 450px;
              overflow: auto;

              .tabInfosList {
                padding: 10px 0;
                border-bottom: 1px solid #D9D9D9;
                border-bottom-style: dashed;

                .infoListHeader {
                  display: flex;
                  justify-content: space-between;

                  .tagAndTime {
                    display: flex;
                    align-items: center;

                    .tagShow {
                      position: relative;
                      color: white;
                      height: 20px;
                      line-height: 20px;
                      padding: 0 15px 0 10px;
                    }

                    .tagShow::before {
                      content: "";
                      position: absolute;
                      bottom: 0;
                      right: 0;
                      width: 0;
                      height: 0;
                      border-left: 10px solid transparent;
                      border-bottom: 20px solid white;
                    }

                    .timeShow {
                      margin-left: 10px;
                      color: #404040;
                      font-size: 14px;
                    }
                  }
                }

                .infoListContent {
                  cursor: pointer;
                  margin-top: 5px;
                  font-size: 20px;
                  font-weight: 500;
                  color: #013c80;
                  text-align: left;
                }

                .infoListNewContent {
                  position: relative;
                  color: #CF0B1E !important;
                }

                .infoListNewContent::after {
                  content: "New";
                  color: #fff;
                  background: linear-gradient(0deg, #DD3037 0%, #B61D2C 100%);
                  border-radius: 5px 5px 5px 0;
                  padding: 2px;
                  margin-left: 5px;
                  font-size: 12px;
                  position: absolute;
                  bottom: 20px;
                }
              }
            }

            .tabInfosShow::-webkit-scrollbar {
              width: 5px;
              height: 100%;
            }

            // 滑块
            .tabInfosShow::-webkit-scrollbar-thumb {
              width: 5px;
              height: 60px;
              background-color: #ccc;
              border-radius: 3px;
            }
          }

          .rightTwitter {
            flex: 3;
            //height: 65vh;
            background-color: white;
            overflow: auto;
          }

          .rightTwitter::-webkit-scrollbar {
            width: 5px;
            height: 100%;
          }

          // 滑块
          .rightTwitter::-webkit-scrollbar-thumb {
            width: 5px;
            height: 60px;
            background-color: #ccc;
            border-radius: 3px;
          }

        }
      }
    }
    @media screen and (min-width: 2561px) {
      .page2Main {
        width: 60%;
        margin: auto;

        .page2Title {
          color: white;
          text-align: center;
          font-size: 60px;
          font-weight: bold;
          margin-bottom: 50px;
        }

        .page2Content {
          height: auto;
          display: flex;
          justify-content: center;
          align-items: stretch;
          .leftList {
            flex: 5;
            //height: 65vh;
            background: #fffffff5;
            margin-right: 20px;

            .tabList {
              display: flex;
              background: white;

              .tabListShow {
                flex: 1;
                height: 85px;
                line-height: 85px;
                font-size: 30px;
                color: #808080;
                cursor: pointer;
              }

              .tabListActive {
                color: white !important;
                background: url("@/assets/imgs/tabBg.png");
                background-size: 100% 100%;
              }
            }

            .tabInfosShow {
              padding: 0 10px;
              height: 690px;
              overflow: auto;

              .tabInfosList {
                padding: 10px 0;
                border-bottom: 1px solid #D9D9D9;
                border-bottom-style: dashed;

                .infoListHeader {
                  display: flex;
                  justify-content: space-between;

                  .tagAndTime {
                    display: flex;
                    align-items: center;

                    .tagShow {
                      position: relative;
                      color: white;
                      height: 40px;
                      line-height: 40px;
                      padding: 0 15px 0 10px;
                      font-size: 25px;
                    }

                    .tagShow::before {
                      content: "";
                      position: absolute;
                      bottom: 0;
                      right: 0;
                      width: 0;
                      height: 0;
                      border-left: 10px solid transparent;
                      border-bottom: 40px solid white;
                    }

                    .timeShow {
                      margin-left: 10px;
                      color: #404040;
                      font-size: 23px;
                    }
                  }
                }

                .infoListContent {
                  cursor: pointer;
                  margin-top: 5px;
                  font-size: 20px;
                  font-weight: 500;
                  color: #013c80;
                  text-align: left;
                }

                .infoListNewContent {
                  position: relative;
                  color: #CF0B1E !important;
                  font-size: 35px;
                }

                .infoListNewContent::after {
                  content: "New";
                  color: #fff;
                  background: linear-gradient(0deg, #DD3037 0%, #B61D2C 100%);
                  border-radius: 5px 5px 5px 0;
                  padding: 2px;
                  margin-left: 5px;
                  font-size: 20px;
                  position: absolute;
                  bottom: 20px;
                }
              }
            }

            .tabInfosShow::-webkit-scrollbar {
              width: 5px;
              height: 100%;
            }

            // 滑块
            .tabInfosShow::-webkit-scrollbar-thumb {
              width: 5px;
              height: 60px;
              background-color: #ccc;
              border-radius: 3px;
            }
          }

          .rightTwitter {
            flex: 3;
            height: 65vh;
            background-color: white;
            overflow: auto;
          }

          .rightTwitter::-webkit-scrollbar {
            width: 5px;
            height: 100%;
          }

          // 滑块
          .rightTwitter::-webkit-scrollbar-thumb {
            width: 5px;
            height: 60px;
            background-color: #ccc;
            border-radius: 3px;
          }

        }
      }
    }

    .page3Main {
      width: 70%;
      margin: auto;

      .swiperPage3Main {
        display: flex;
        //justify-content: space-between;
        //margin: auto;

        .leftContent {
          width: 25vw;
          margin: auto 0;
          padding: 0 10px;
          @media screen and (max-width: 1920px) {
            .leftTitleShow {
              text-align: left;
              font-size: 30px;
            }

            .leftDetail {
              text-align: left;
              margin: 20px 0;
              font-size: 14px;
            }
          }
          @media screen and (min-width: 1921px) and (max-width: 2560px) {
            .leftTitleShow {
              text-align: left;
              font-size: 50px;
            }

            .leftDetail {
              text-align: left;
              margin: 20px 0;
              font-size: 25px;
            }
          }
          @media screen and (min-width: 2561px) {
            .leftTitleShow {
              text-align: left;
              font-size: 70px;
            }

            .leftDetail {
              text-align: left;
              margin: 40px 0;
              font-size: 40px;
            }
          }
        }

        .swiper-container-page3 {
          width: 26vw;

          .rightImg {
            width: 25vw;

            img {
              width: 100%;
            }
          }
        }
      }
    }

    @media screen and (max-width: 1920px) {
      .page4Main {
        width: 900px;
        margin: 5% auto auto;

        .titleShow {
          text-align: center;
          font-size: 30px;
          font-weight: bold;
          padding: 20px 0;
          background: url("@/assets/imgs/page4TitleBg.png") no-repeat center;
          background-size: contain;
          margin-bottom: 60px;
        }

        .cardList {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .cardListShow {
            flex: 1 0 30%;
            max-width: 30%;
            padding: 5px;
            cursor: pointer;

            img {
              width: 100%;
            }
          }
        }
      }
    }
    @media screen and (min-width: 1921px) and (max-width: 2560px) {
      .page4Main {
        width: 50vw;
        margin: 20vh auto auto;

        .titleShow {
          text-align: center;
          font-size: 50px;
          font-weight: bold;
          padding: 40px 0;
          background: url("@/assets/imgs/page4TitleBg.png") no-repeat center;
          background-size: contain;
          margin-bottom: 60px;
        }

        .cardList {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .cardListShow {
            flex: 1 0 30%;
            max-width: 30%;
            padding: 5px;
            cursor: pointer;

            img {
              width: 100%;
            }
          }
        }
      }
    }
    @media screen and (min-width: 2561px) {
      .page4Main {
        width: 50vw;
        margin: 20vh auto auto;

        .titleShow {
          text-align: center;
          font-size: 70px;
          font-weight: bold;
          padding: 40px 0;
          background: url("@/assets/imgs/page4TitleBg.png") no-repeat center;
          background-size: contain;
          margin-bottom: 60px;
        }

        .cardList {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .cardListShow {
            flex: 1 0 30%;
            max-width: 30%;
            padding: 5px;
            cursor: pointer;

            img {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .swiper-pagination {
    /deep/ .swiper-pagination-bullet {
      width: 10px; /* 设置大小 */
      height: 10px;
      margin: 0 15px;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: white;
    }
  }

  .page3Swiper-pagination {
    text-align: left;

    /deep/ .swiper-pagination-bullet {
      width: 10px; /* 设置大小 */
      height: 10px;
      margin: 0 5px;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: black;
    }
  }
}
</style>
